import styled from 'styled-components'

export const CheckoutWrapper = styled.div`
  margin: 6rem 20px 0 20px;

  .proceed_btn {
    margin-top: 4rem;
  }

  .flex_container {
    display: flex;
    justify-content: space-between;
  }

  /* .btn_container {
    height: 300px;
  } */
`

export const PaymentWrapper = styled.div``

export const ManualWrapper = styled.div``

export const AutomatedWrapper = styled.div``
